import { render, staticRenderFns } from "./BoardPage.vue?vue&type=template&id=5615c021"
import script from "./BoardPage.vue?vue&type=script&lang=js"
export * from "./BoardPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports